import { render, staticRenderFns } from "./TwEntityButtons.vue?vue&type=template&id=625a070a&"
import script from "./TwEntityButtons.vue?vue&type=script&lang=js&"
export * from "./TwEntityButtons.vue?vue&type=script&lang=js&"
import style0 from "./TwEntityButtons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports